import { siteConfig } from '@seek/melways-sites';

import { environments } from 'src/siteConfig';

import { defaultWindowConfig } from '../../utils/window';

const MOCK_API_ORIGIN = 'http://localhost:3000';

const GRAPHQL_PATH = '/graphql';

class ConfigurationService {
  get config() {
    return typeof window !== 'undefined' && window.config
      ? window.config
      : defaultWindowConfig;
  }

  getSite() {
    return this.config.site;
  }

  getLanguage() {
    return this.config.language;
  }

  getEnvironment() {
    return this.config.environment;
  }

  isStaging() {
    return this.getEnvironment() === environments.staging;
  }

  isLocalDev() {
    return this.getEnvironment() === environments.development;
  }

  isUsingLocalAuth() {
    return this.config.localAuth === true;
  }

  getRelativeUrl(path: string) {
    const host = this.isLocalDev() ? MOCK_API_ORIGIN : '';

    return `${host}${path}`;
  }

  getGraphqlUrl(subPath: string) {
    if (this.getEnvironment() === environments.development) {
      return `${MOCK_API_ORIGIN}${GRAPHQL_PATH}`;
    }
    return `${subPath}${GRAPHQL_PATH}`;
  }

  getEventCaptureApiUrl() {
    switch (this.getEnvironment()) {
      case environments.development:
        return this.getRelativeUrl('/api/event-capture');
      case environments.staging:
        return 'https://hirer-ecapi.staging.cloud.seek.com.au/';
      case environments.production:
      default:
        return 'https://hirer-ecapi.cloud.seek.com.au/';
    }
  }

  getHirerGraphqlUrl() {
    return this.getGraphqlUrl('');
  }

  getCountryCode() {
    return siteConfig[this.getSite()].classification.country.toUpperCase();
  }

  getAppVersion() {
    return this.config.version;
  }

  getAppBranch() {
    return this.config.branch;
  }
}

export default new ConfigurationService();
